var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconBtnCheck = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3508 4.15938C13.7537 4.53711 13.7741 5.16995 13.3964 5.57286L7.56304 11.7951C7.19237 12.1905 6.57421 12.2186 6.16914 11.8586L2.66914 8.74744C2.25636 8.38052 2.21918 7.74845 2.5861 7.33567C2.95302 6.92288 3.58509 6.8857 3.99787 7.25262L6.77002 9.71675L11.9373 4.20498C12.315 3.80207 12.9479 3.78165 13.3508 4.15938Z",
    fill: "#29B5BC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconBtnCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_btn_check.ef4279baba2c1a62d1434d75784de3dc.svg";